export function initProjects() {

	var Page = Barba.BaseView.extend({

		namespace: 'page-projets',

		onEnter: function() {

			//console.log('Init Projects');
			
			this.DOM = {};
			this.DOM.hero = this.container.querySelector('.hero');
			this.DOM.brand = document.querySelector('header .brand');
			this.DOM.projects = this.container.querySelectorAll('.project--preview');
			this.pageSy = window.pageYOffset || document.documentElement.scrollTop;
			
			var mouseEnter = (e) => { e.currentTarget.querySelector('.video--cover').play(); }
			var mouseLeave = (e) => { e.currentTarget.querySelector('.video--cover').pause(); }
			
			this.DOM.projects.forEach((item) => {
				
				item.querySelector('.video--cover').currentTime = 2;
				
				item.addEventListener('mouseenter', mouseEnter);
				item.addEventListener('touchstart', mouseEnter);
				
				item.addEventListener('mouseleave', mouseLeave);
				item.addEventListener('touchend', mouseLeave);
				
			});
			
			window.addEventListener('scroll', this.onPageScroll);

		},
		
		onLeave : function(){
			window.removeEventListener('scroll', this.onPageScroll);
		},

	});
	
	Page.onPageScroll = (e) => {
		Page.pageSy = window.pageYOffset || document.documentElement.scrollTop;
		if(Page.pageSy > (Page.DOM.hero.offsetHeight - Page.DOM.brand.offsetTop)) {
			if (!document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.add('white');
		} else {
			if (document.querySelector('body > header').classList.contains('white')) document.querySelector('body > header').classList.remove('white');
		};
	}

	Page.init();

}
